module.exports = __webpack_public_path__ + "img/tuijianchapin.0c117eeb.png";